<template lang="pug">
  b-row.mb-5
    b-col
      router-view(@roles-changed='reloadAccountsPanel')
</template>

<script>
export default {
  name: 'manager-accounts-roles',
  methods: {
    reloadAccountsPanel() {
      this.$parent.$refs.accountsPanel.panelReload()
    },
  },
}
</script>
